<template>
  <td v-if="renderCell" :class="className" class='text-center' 
    colspan="1" 
    :data-grid-col-index="columnIndex"  
    role="gridcell"
    >
    <input
      class='k-checkbox'
      type='checkbox'
      :disabled="true"
      :checked="getNestedValue(field, dataItem)"
      :aria-label="field"
    />
  </td>
  <td
    v-else-if="renderArrow"
    key="'g' + columnIndex"
    :class="'k-group-cell'"
    colspan="1" 
    :data-grid-col-index="columnIndex"
    role="gridcell"
  ></td>
  <td
    v-else-if="columnIndex <= level"
    key='g-colspan'
    :colSpan="columnsCount - columnIndex"
    :data-grid-col-index="columnIndex"
    role="gridcell"
  >
    <p class='k-reset'>
      <a
        @click="onClick"
        tabIndex='-1'
        href='#'
        :class="expanded ? 'k-i-collapse k-icon' : 'k-i-expand k-icon'"
      />
      {{ dataItem[field] }}
    </p>
  </td>
</template>
<script>
function nestedValue (fieldName, dataItem) {
  const path = fieldName.split('.')
  let data = dataItem
  path.forEach((p) => {
    data = data ? data[p] : undefined
  })

  return data
}

export default {
  emits: {
    click: null
  },
  props: {
    field: String,
    dataItem: Object,
    format: String,
    className: String,
    columnIndex: Number,
    columnsCount: Number,
    rowType: String,
    level: Number,
    expanded: Boolean,
    editor: String
  },
  computed: {
    renderArrow () {
      var returnValue =
        this.columnIndex === undefined ||
        this.level === undefined ||
        this.columnIndex < this.level ||
        this.columnsCount === undefined ||
        this.rowType !== 'groupHeader' ||
        this.dataItem[this.field] === undefined
      return returnValue && this.dataItem[this.field]
    },
    renderCell () {
      return this.field !== undefined && this.rowType !== 'groupHeader'
    }
  },
  methods: {
    onClick (e) {
      // @ts-ignore
      this.$emit('click', e, this.dataItem, this.expanded)
    },
    getNestedValue: nestedValue
  }
}
</script>

<style scoped>
.bg-success-p{
  background-color: black;
}
</style>
